import {fetchPINBegin, fetchPINSuccess} from "../action/pinAction";

export function setPin(pin) {
    return dispatch => {
        dispatch(fetchPINBegin());
        dispatch(fetchPINSuccess(pin));
    };
}
